import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { TabBar } from './TabBar';
import { CreateTaskSheet } from '@/features/tasks/CreateTaskSheet';
import { useCreateTask } from '@/features/tasks/hooks/useTasks';
import { useDoorOpen } from '@/features/door/hooks/useDoorOpen';

export function Layout() {
  const [quickCreateOpen, setQuickCreateOpen] = useState(false);
  const createTask = useCreateTask();
  const { openDoor } = useDoorOpen();

  return (
    <div className="min-h-screen min-h-[100dvh] bg-background flex flex-col">
      {/* Main content area */}
      <main className="flex-1 overflow-y-auto overflow-x-hidden pb-[var(--tab-bar-height)]">
        <Outlet />
      </main>

      {/* Fixed bottom navigation */}
      <TabBar
        onTasksLongPress={() => setQuickCreateOpen(true)}
        onMoreLongPress={openDoor}
      />

      {/* Quick create personal task (long-press on Tasks tab) */}
      <CreateTaskSheet
        open={quickCreateOpen}
        onOpenChange={setQuickCreateOpen}
        onCreate={(dto) => createTask.mutate(dto)}
        isCreating={createTask.isPending}
        presetType="PERSONAL"
      />
    </div>
  );
}
